import { Module, ActionTree, MutationTree, GetterTree } from 'vuex';
import { GlobalState } from '../types';
import { SiteNotifyState } from './types';

import * as myetaapi from '../../api/myeta';

export const state: SiteNotifyState = {
    available: false,
    open: false,
    error: null,
    url: null,
    ws: null,
};

export const actions: ActionTree<SiteNotifyState, GlobalState> = {
    async open({ commit, dispatch, rootGetters }) {
        if (("WebSocket" in window) && (rootGetters['$auth/isAuthenticated'])) {
            // get sitenotify from api
            const sitenotify = await myetaapi.getSiteNotify();
            if (sitenotify && sitenotify.url) {
                commit('setAvailable');
                commit('setAreas', { areas: sitenotify.areas });

                await dispatch('reconnect', sitenotify.url);
                
                // probably need a timer to check if connection is still live
            }
        }
    },
    async close({ commit }, params) {
        // must have retrieved the url at least once to reconnect
        // must not be open and not in error
        if (state.available && state.open && state.ws) {
            state.ws.close();
            commit('setClosed', { force: true });
        }
    },
    async message({ commit, dispatch }, params) {
        commit('onMessage', params);
        if (params) {
            console.log('pulling sessions');
            await dispatch('$sessions/pull', null, { root: true});
        }
    },
    async reconnect({ commit, state, dispatch }, params) {
        // must have retrieved the url at least once to reconnect
        // must not be open and not in error
        if (state.available && !state.open && !state.error) {
            // get the url either by pass in or refetch
            let url!: string;
            if (!params) {
                // do a full retrieve
                const sitenotify = await myetaapi.getSiteNotify();
                if (sitenotify && sitenotify.url) {
                    url = sitenotify.url;

                    // refresh the areas to latest
                    commit('setAreas', { areas: sitenotify.areas });
                }
            } else {
                url = params;
            }

            // hook up websocket if it's available
            var ws = new WebSocket(url);
            ws.onopen = () => {
                commit('setOpened', { ws, url });
            };

            ws.onerror = () => {
                commit('setError');
            };

            ws.onmessage = (evt) => { 
                dispatch('message', evt.data);
            };
            
            ws.onclose = () => { 
                commit('setClosed');
                dispatch('reconnect');
            };
        }
    }
};

export const mutations: MutationTree<SiteNotifyState> = {
    setAvailable(state) {
        state.available = true;
        console.log('ws available');
    },
    setAreas(state, payload) {
        //state.available = true;
        console.log('set areas', payload);
    },
    setOpened(state, payload) {
        state.open = true;
        state.url = payload.url;
        state.ws = payload.ws;
        console.log('ws opened');
    },
    setError(state) {
        state.error = "error";
        state.url = null;
        state.ws = null;
        console.log('ws error');
    },
    setClosed(state, payload) {
        state.open = false;
        state.url = null;
        state.ws = null;
        if (payload && payload.force) {
            state.available = false;
            console.log('ws force closed');
        } else {
            console.log('ws closed');
        }
    },
    onMessage(state, payload) {
        console.log('site notify message', payload);
    },
};

export const getters: GetterTree<SiteNotifyState, GlobalState> = {
    connected(state): boolean | null {
        return state.available && state.open;
    }
};

const namespaced: boolean = true;
export const sitenotify: Module<SiteNotifyState, GlobalState> = {
    namespaced,
    state,
    actions,
    mutations,
    getters,
};
